import { string } from "prop-types";
import CustomIcon from "../components/common/CustomIcons";
import { GetImages } from "../utils/GetImages";
import Localizer from "../utils/i18nConfig";

export const USERS = {
  USER: "USER",
  TENANT: "TENANT",
  CONTRACTOR: "CONTRACTOR",
  LeaseApplication: "LEASEAPPLICATION",
  PLATFORM: "PLATFORM"
};

export const USER_ROLES = {
  "0": USERS.PLATFORM,
  "1": USERS.USER,
  "4": USERS.TENANT,
  "6": USERS.CONTRACTOR,
  "2": USERS.LeaseApplication
};

export const CUSTOM_COLORS = {
  lightGray: "#E5E7EB",
  skyDarkBlue: "#0DBF6F",
  lightGreen: "#1A56DB",
};

export const LOCALE_OPTIONS = {
  EN: "en",
  EN_GB: "en-GB",
  EN_US: "en-US",
  FR: "fr",
};
export type Language_Type =
  (typeof LOCALE_OPTIONS)[keyof typeof LOCALE_OPTIONS];

export const URLS = {
  HOME: "/",
  UNITS: "/units",
  EDIT_UNIT: "/units/edit",
  PROPERTIES: "/properties",
  TENANTS: "/tenants",
  CREATE_TENANT: "/tenants/create",
  TENANT_TYPE: "/tenants/tenantType",
  SERVICE_REQUESTS: "/servicerequest",
  CONTRACTORS: "/contractors",
  ORGANIZATION: "/organization",
  PLATFORMSETTINGS: "/platform-settings",
  MY_SETTINGS: "/my-settings",
  PAYMENT: "/payment",
  TRANSACTION: "/transaction",
  CREATE_PAYMENT: "/payment/create",
  SETTLE_PAYMENT: "/payment/settle-payment/:id",
  MESSAGING: "/messaging",
  CALCULATOR: "/calculators",
  INFO: "/info",
  FIRST_TIME_DASHBOARD: "/firsttimedashboard",
  ORGANIZATION_ACCOUNTS: "/accounting",
  PAYMENT_DUE_ACCOUNTS: "/paymentDueAccounts",
  PAYEE_ACCOUNT_MANAGEMENT: "/payeeAccounts",
  USER_DASHBOARD: "/userdashboard",
  QUESTIONNAIRE: "/questionnaire",
  FORGET_PASSWORD: "/forgetpassword",
  CHECK_MAIL: "/checkemail",
  SIGN_UP: "/signup",
  SIGNUP_AFTER_GOOGLE: "/signupaftergoogle",
  CHECK_MAIL_AFTER_SIGNUP: "/checkemailaftersignup",
  RESET_PASSWORD_BY_USERKEY: "/resetpassword/:userKey",
  SETUP_PASSWORD_BY_USERKEY: "/setpassword/:userKey",
  TENANT_ONBOARD: "/leaseApplication",
  TENANT_ONBOARD_NEW: "/leaseApplicationNew",
  LOGIN: "/login",
  SET_PASSWORD: "/setpassword",
  GENERATE_PDF_DOCUMENT: "/generatePdfDocument/*",
  GENERATE_EMAIL: "/generateEmail/*",
  TENANT_SERVICE_REQUESTS: "/servicerequest",
  TRANSACTIONS: "/transactions",
  CHAT: "/chat",
  MY_PROFILE: "/profile",
  LEASE_DETAILS: "/leaseDetails",
  PAYMENT_METHODS: "/paymentMethods",
  INVITE_USER: "/orgUser",
  EMAIL: "/messaging/email",
  MESSAGE: "/messaging/chat",
  PROPERTIES2:"properties2",
  // Platform super-admin portal
  PLATFORM_ORGANIZATIONS: "/platform-organizations",
  PLATFORM_SUPPORT: "/platform-support",
  PLATFORM_PAYMENT_ACCOUNTS: "/platform-payment-accounts",
  // Platform Settings sub-shell (reached from the top-right menu) — groups the platform-only surfaces.
  PLATFORM_SETTINGS: "/platform-settings",
  PLATFORM_SETTINGS_PAYMENT_ACCOUNTS: "/platform-settings/payment-accounts",
  PLATFORM_SETTINGS_SUPPORT: "/platform-settings/support",
  PLATFORM_SETTINGS_ORGANIZATIONS: "/platform-settings/organizations",
  PLATFORM_SETTINGS_MAINTENANCE_BANNERS: "/platform-settings/maintenance-banners",
  PLATFORM_SETTINGS_SERVER_TOOLS: "/platform-settings/server-tools"
};

export const MAIN_ROUTES_URLS = {
  HOME: `${URLS.HOME}*`,
  UNITS: `/${URLS.UNITS}/*`,
  PROPERTIES: `/${URLS.PROPERTIES}/*`,
  TENANTS: `/${URLS.TENANTS}/*`,
  SERVICE_REQUESTS: `/${URLS.SERVICE_REQUESTS}/*`,
  CONTRACTORS: `/${URLS.CONTRACTORS}/*`,
  ORGANIZATION: `/${URLS.ORGANIZATION}/*`,
  PLATFORMSETTINGS: `/${URLS.PLATFORMSETTINGS}/*`,
  MY_SETTINGS: `${URLS.MY_SETTINGS}/*`,
  PAYMENT: `${URLS.PAYMENT}/*`,
  TRANSACTION: `${URLS.TRANSACTION}/*`,
  CALCULATOR: `/${URLS.CALCULATOR}/*`,
  MESSAGING: `/${URLS.MESSAGING}/*`,
  INFO: `/${URLS.INFO}/*`,
  ORGANIZATION_ACCOUNTS: `/${URLS.ORGANIZATION_ACCOUNTS}/*`,
  PAYMENT_DUE_ACCOUNTS: `/${URLS.PAYMENT_DUE_ACCOUNTS}/*`,
  PAYEE_ACCOUNT_MANAGEMENT: `/${URLS.PAYEE_ACCOUNT_MANAGEMENT}/*`,
  GENERATE_PDF_DOCUMENT: `/${URLS.GENERATE_PDF_DOCUMENT}/*`,
  GENERATE_EMAIL: `/${URLS.GENERATE_EMAIL}/*`,
  TENANT_SERVICE_REQUESTS: `${URLS.TENANT_SERVICE_REQUESTS}/*`,
  TRANSACTIONS: `${URLS.TRANSACTIONS}/*`,
  CHAT: `${URLS.CHAT}/*`,
  LEASE_DETAILS: `${URLS.LEASE_DETAILS}/*`,
  PAYMENT_METHODS: `${URLS.PAYMENT_METHODS}/*`,
  MY_PROFILE: `${URLS.MY_PROFILE}/*`,
  TENANT_ONBOARD: `${URLS.TENANT_ONBOARD}`,
  TENANT_ONBOARD_NEW:`${URLS.TENANT_ONBOARD_NEW}`,
  INVITE_USER: `${URLS.INVITE_USER}`,
  PROPERTIES2:`${URLS.PROPERTIES2}`,
  PLATFORM_ORGANIZATIONS: `${URLS.PLATFORM_ORGANIZATIONS}/*`,
  PLATFORM_SUPPORT: `${URLS.PLATFORM_SUPPORT}/*`,
  PLATFORM_PAYMENT_ACCOUNTS: `${URLS.PLATFORM_PAYMENT_ACCOUNTS}/*`,
  PLATFORM_SETTINGS: `${URLS.PLATFORM_SETTINGS}/*`

};


export const FORM_CONTROLFIELD_TYPES = {
  NUMBER: "number",
  TEXT: "text",
  TEXTAREA: 'textarea',
  EMAIL: "email",
  PASSWORD: "password",
  DATE: "date",
  CURRENCY: "currency",
  TELEPHONE: "tel",
  MOBILE: "mobile",
  INTEGER: "number",
  CHECKBOX:"checkbox"
};

export const generateMenuRoutes = (values, userRoleId: string | number) => {
  switch (userRoleId) {
    //USERCASE
    case 1:
      return [
        {
          id: "1",
          path: URLS.PROPERTIES,
          permission: "Property",
          primaryText: `${Localizer.getLocalizedString("properties_title")} ${values.noOfProperties
            }`,
          leftIcon: GetImages.selectedPropertiesIconMenu,
          selectedIcon: GetImages.selectedPropertiesIconMenu,
        },
        {
          id: "2",
          path: URLS.UNITS,
          permission: "Unit",
          primaryText: `${Localizer.getLocalizedString("units_title")} ${values?.noOfUnits
            }`,
          leftIcon: GetImages.unitIconMenu,
          selectedIcon: GetImages.unitIconMenu,
        },
        {
          id: "3",
          path: URLS.TENANTS,
          permission: "Tenant",
          primaryText: `${Localizer.getLocalizedString("tenants_title")} ${values.noOfTenants
            }`,
          leftIcon: GetImages.tenantIconMenu,
          selectedIcon: GetImages.tenantIconMenu,
        }
        // {
        //   id: "4",
        //   path: URLS.PROPERTIES2,
        //   primaryText: `${Localizer.getLocalizedString("new_properties")} ${values.noOfTenants
        //     }`,
        //   leftIcon: GetImages.tenantIconMenu,
        //   selectedIcon: GetImages.selectedTenantIconMenu,
        // },
      ];
    case 2:
      return [
        {
          id: "1",
          path: URLS.TENANT_ONBOARD,
          permission: "Leases",
          primaryText: `${Localizer.getLocalizedString("properties_title")} ${values.noOfProperties }`,
          leftIcon: GetImages.propertiesIconMenu,
          selectedIcon: GetImages.propertiesIconMenu,
        },
      ]
    //TENANTCASE
    case 4:
      return [
        {
          id: "1",
          path: URLS.TENANT_SERVICE_REQUESTS,
          permission: "ServiceRequest",
          primaryText: "Service request",
          leftIcon: GetImages.tenantServiceRequestIcon,
          selectedIcon: GetImages.tenantServiceRequestIcon,
        },
        {
          id: "2",
          path: URLS.LEASE_DETAILS,
          permission: "Leases",
          primaryText: "Lease Details",
          leftIcon: GetImages.tenantLeaseIcon,
          selectedIcon: GetImages.tenantLeaseIcon,
        },
        {
          id: "3",
          path: URLS.PAYMENT_METHODS,
          permission: "Payments",
          primaryText: "Payment Methods",
          leftIcon: GetImages.tenantPaymentMethodIcon,
          selectedIcon: GetImages.tenantPaymentMethodIcon,
        },
      ];
    case 6:
      return [
        {
          id: "1",
          path: URLS.INFO,
          permission: "MyProfile",
          primaryText: "My info",
          leftIcon: (
            <CustomIcon
              src={GetImages.serviceRequestIconMenu}
              alt={"Service Request"}
            />
          ),
        },
        {
          id: "2",
          path: URLS.SERVICE_REQUESTS,
          permission: "ServiceRequest",
          primaryText: `Service Request  ${values.noOfServiceRequests}`,
          leftIcon: (
            <CustomIcon
              src={GetImages.serviceRequestIconMenu}
              alt={"Service Request"}
            />
          ),
        },
        {
          id: "3",
          path: URLS.PAYMENT_DUE_ACCOUNTS,
          permission: "PaymentAccounts",
          primaryText: "Payment Due Accounts",
          leftIcon: (
            <CustomIcon
              src={GetImages.serviceRequestIconMenu}
              alt={"Service Request"}
            />
          ),
        },
        {
          id: "4",
          path: URLS.PAYEE_ACCOUNT_MANAGEMENT,
          permission: "PayeeAccounts",
          primaryText: "Payee Account Management",
          leftIcon: (
            <CustomIcon
              src={GetImages.serviceRequestIconMenu}
              alt={"Service Request"}
            />
          ),
        },
      ];
    default: {
      return null;
    }
  }
};

export const generateMaintananceMenuRoutes = (values, userRoleId: string | number) => {
  switch (userRoleId) {
    //USERCASE
    case 1:
      return [
        {
          id: "4",
          path: URLS.SERVICE_REQUESTS,
          permission: "ServiceRequest",
          primaryText: `${Localizer.getLocalizedString(
            "service_requests_title"
          )} ${values.noOfServiceRequests}`,
          leftIcon: GetImages.serviceRequestIconMenu,
          selectedIcon: GetImages.serviceRequestIconMenu,
        },
        {
          id: "5",
          path: URLS.CONTRACTORS,
          permission: "Contractor",
          primaryText: `${Localizer.getLocalizedString("contractors_title")} ${values.noOfContractors
            }`,
          leftIcon: GetImages.contractorIconMenu,
          selectedIcon: GetImages.contractorIconMenu,
        },
      ];
    default: {
      return null;
    }
  }
};

export const generateCommunicationMenuRoutes = (values, userRoleId: string | number) => {
  switch (userRoleId) {
    //USERCASE
    case 1:
      return [
         {
          id: "3",
          path: URLS.MESSAGE,
          permission: "Message",
          primaryText: "Messages",
          leftIcon: GetImages.Messages,
          selectedIcon: GetImages.Messages,
        },
        {
          id: "2",
          path: URLS.EMAIL,
          permission: "Email",
          primaryText: "Email",
          leftIcon: GetImages.Email,
          selectedIcon: GetImages.Email,
        },
       
      ];
    default: {
      return null;
    }
  }
}

export const generateAccountMenuRoutes = (values, userRoleId: string | number) => {
  switch (userRoleId) {
    //USERCASE
    case 1:
      return [
        {
          id: "12",
          path: URLS.PAYMENT,
          permission: "Payments",
          primaryText: `${Localizer.getLocalizedString("payment_title")}`,
          leftIcon: GetImages.accountingIconMenu,
          selectedIcon: GetImages.accountingIconMenu,
        },
        {
          id: "13",
          path: URLS.TRANSACTION,
          permission: "Transaction",
          primaryText: `${Localizer.getLocalizedString("transaction_title")}`,
          leftIcon: GetImages.GreyTransaction,
          selectedIcon: GetImages.GreyTransaction,
        },
      ];
    default: {
      return null;
    }
  }
};

// Platform "Platform Settings" sub-shell nav (reached from the top-right menu). The main platform left-nav is
// now the organization menu (the portal impersonates the selected org); these are the platform-only surfaces.
// A Platform token carries no per-module permissions, so these entries are intentionally NOT permission-gated —
// access is controlled purely by the App.tsx Platform role branch.
export const generatePlatformMenuRoutes = () => {
  return [
    {
      id: "1",
      path: URLS.PLATFORM_SETTINGS_PAYMENT_ACCOUNTS,
      primaryText: "Payment Accounts",
      leftIcon: GetImages.paymentAccOrgIcon,
      selectedIcon: GetImages.paymentAccOrgIcon,
    },
    {
      id: "2",
      path: URLS.PLATFORM_SETTINGS_SUPPORT,
      primaryText: "Support Requests",
      leftIcon: GetImages.serviceRequestIconMenu,
      selectedIcon: GetImages.serviceRequestIconMenu,
    },
    {
      id: "3",
      path: URLS.PLATFORM_SETTINGS_ORGANIZATIONS,
      primaryText: "Organizations",
      leftIcon: GetImages.propertiesIconMenu,
      selectedIcon: GetImages.selectedPropertiesIconMenu,
    },
    {
      id: "4",
      path: URLS.PLATFORM_SETTINGS_MAINTENANCE_BANNERS,
      primaryText: "Maintenance Banners",
      leftIcon: GetImages.notificatioIcon,
      selectedIcon: GetImages.notificatioIcon,
    },
    {
      id: "5",
      path: URLS.PLATFORM_SETTINGS_SERVER_TOOLS,
      primaryText: "Server Tools",
      leftIcon: GetImages.SettingIcon,
      selectedIcon: GetImages.BlueSettingIcon,
    },
  ];
};

export const tenantFields = [
  { label: "First name", placeholder: "Enter First name", name: "firstName" },
  { label: "Last name", placeholder: "Enter Last Name", name: "lastName" },
  {
    label: "Phone Number",
    placeholder: "Enter Phone Number",
    name: "phoneNumber",
  },
  { label: "Email address", placeholder: "Enter email", name: "email" },
];
// Its alternative method is written : DateHelper.convertUTCtoDateTimeSimple(myDateString, showTime);
export const convertDate = (requestDateStr) => {
  const requestDateObj = new Date(requestDateStr);

  const formattedDate = requestDateObj.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return formattedDate;
};

export const getBathroomText = (number, text) => {
  return number > 1 ? `${text}s` : text;
};

export const defaultPageNo = 1;
export const defaultPageSize = 10;
